import { makeAutoObservable, observable } from "mobx";

/** Stable defaults for omitted slot arrays (avoid new [] per call). */
export const APP_BAR_EMPTY_ACTIONS = [];
export const APP_BAR_EMPTY_MIDDLE_COMPONENTS = [];
export const APP_BAR_EMPTY_RIGHT_COMPONENTS = [];

class AppBarStore {
  title = "";
  actions = [];
  backAction = null;
  middleComponents = [];
  rightComponents = [];
  /** When true, {@link AuthenticatedLayout} may hide the fixed top bar on desktop. */
  suppressFixedBar = false;
  /** When true on mobile, the global nav hamburger is hidden (e.g. Prompts mobile editor uses its own close control). */
  hideMobileMenuButton = false;
  /**
   * When true with {@link hideMobileMenuButton} on mobile, render {@link rightComponents} on the same row as the title
   * (e.g. version history + Try it next to “Edit Prompt” / “New Prompt”).
   */
  mobileTitleRowInlineActions = false;
  /** Mobile map overlay pages: dark frosted app bar (title + icon buttons match map chrome). */
  mobileGlassMapHeader = false;
  /** Mobile map pages with drawer closed: opaque lavender app bar (matches Properties chrome). */
  mobileLavenderMapHeader = false;

  constructor() {
    // Keep UI payloads (React nodes/functions) by reference.
    makeAutoObservable(this, {
      actions: observable.ref,
      backAction: observable.ref,
      middleComponents: observable.ref,
      rightComponents: observable.ref,
    });
  }

  /**
   * Configure the AppBar for the current view.
   * @param {Object} config - { title?, actions?, backAction?, middleComponents?, rightComponents?, suppressFixedBar?, hideMobileMenuButton?, mobileTitleRowInlineActions?, mobileGlassMapHeader?, mobileLavenderMapHeader? }
   */
  setConfig({
    title = "",
    actions = APP_BAR_EMPTY_ACTIONS,
    backAction = null,
    middleComponents = APP_BAR_EMPTY_MIDDLE_COMPONENTS,
    rightComponents = APP_BAR_EMPTY_RIGHT_COMPONENTS,
    suppressFixedBar = false,
    hideMobileMenu = false,
    hideMobileMenuButton = false,
    mobileTitleRowInlineActions = false,
    mobileGlassMapHeader = false,
    mobileLavenderMapHeader = false,
  }) {
    this.title = title;
    this.actions = actions;
    this.backAction = backAction;
    this.middleComponents = middleComponents;
    this.rightComponents = rightComponents;
    this.suppressFixedBar = suppressFixedBar;
    this.hideMobileMenu = Boolean(hideMobileMenu);
    this.hideMobileMenuButton = Boolean(hideMobileMenuButton);
    this.mobileTitleRowInlineActions = mobileTitleRowInlineActions;
    this.mobileGlassMapHeader = Boolean(mobileGlassMapHeader);
    this.mobileLavenderMapHeader = Boolean(mobileLavenderMapHeader);
  }

  clear() {
    this.title = "";
    this.actions = [];
    this.backAction = null;
    this.middleComponents = [];
    this.rightComponents = [];
    this.suppressFixedBar = false;
    this.hideMobileMenu = false;
    this.hideMobileMenuButton = false;
    this.mobileTitleRowInlineActions = false;
    this.mobileGlassMapHeader = false;
    this.mobileLavenderMapHeader = false;
  }
}

export const appBarStore = new AppBarStore();
